/**
 * @generated SignedSource<<0830ed4f13e9606f3a54cedffb8cac98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AssignApplianceInput = {
  applianceId: string;
  clientId: string;
};
export type ClientAssignee_assignAppliance_Mutation$variables = {
  input: AssignApplianceInput;
};
export type ClientAssignee_assignAppliance_Mutation$data = {
  readonly assignAppliance: {
    readonly appliance: {
      readonly assignee: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
    };
  } | null;
};
export type ClientAssignee_assignAppliance_Mutation = {
  response: ClientAssignee_assignAppliance_Mutation$data;
  variables: ClientAssignee_assignAppliance_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AssignAppliancePayload",
    "kind": "LinkedField",
    "name": "assignAppliance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Appliance",
        "kind": "LinkedField",
        "name": "appliance",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "assignee",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientAssignee_assignAppliance_Mutation",
    "selections": (v2/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientAssignee_assignAppliance_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4b78cde71a58756a9bccd2ee39268e08",
    "id": null,
    "metadata": {},
    "name": "ClientAssignee_assignAppliance_Mutation",
    "operationKind": "mutation",
    "text": "mutation ClientAssignee_assignAppliance_Mutation(\n  $input: AssignApplianceInput!\n) {\n  assignAppliance(input: $input) {\n    appliance {\n      id\n      assignee {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e5a831839ed82c8653c33003560f4df1";

export default node;
